import { render, staticRenderFns } from "./27100009.vue?vue&type=template&id=4bff36f0&scoped=true&"
import script from "./27100009.vue?vue&type=script&lang=js&"
export * from "./27100009.vue?vue&type=script&lang=js&"
import style0 from "./27100009.vue?vue&type=style&index=0&id=4bff36f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff36f0",
  null
  
)

export default component.exports